// ==============================|| CUSTOM FUNCTION - checkUserPermissions ||============================== //

/**
 * Returns the effective role for the current user + selected venue.
 *
 * 'superadmin' – isSuperAdmin === 1 → full access everywhere.
 * 'admin'      – venue-level admin (isVenueAdmin === 1 for the matched venue).
 * 'staff'      – venue-level staff (venue found but isVenueAdmin === 0).
 *  null         – no access (venue not in user's list, or bad data).
 */
export default function checkUserPermissions(user, selectedVenue) {
    console.log("Checking user permissions with user:", user, "and selectedVenue:", selectedVenue);
  if (!user || !selectedVenue) return null;

  // Super admins bypass everything
  const superFlag = user.isSuperAdmin;
  if (superFlag === 1 || superFlag === true || superFlag === '1' || superFlag === 'true' || superFlag === 'True') {
    return 'superadmin';
  }

  // Must have a venues array
  if (!Array.isArray(user.venues) || user.venues.length === 0) return null;

  // Find the selected venue in the user's venue list
  const match = user.venues.find(
    (v) => String(v.organisationId ?? v.OrganisationId) === String(selectedVenue.orgID ?? selectedVenue.OrgID)
  );

  if (!match) return null;

  // Check admin flag (handle both camelCase and PascalCase)
  const isAdmin = match.isVenueAdmin ?? match.IsVenueAdmin;

  // TEMPORARY ALWAYS RETURN ADMIN, SWAP BACK ONCE NEEDED
  //return isAdmin === 1 || isAdmin === true ? 'staff' : 'staff';
   return isAdmin === 1 || isAdmin === true ? 'admin' : 'staff';
}
